export const TenantStatusesEnum = {
  All: 0,
  Prospect: 1,
  Current: 2,
  Past: 3,
};